<!--
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2023-05-08 15:03:15
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2023-06-01 15:12:38
 * @FilePath: \plantingSubsidy_web_update\src\views\statistics-charts\insurance-statistics\InsuranceLot.vue
 * @Description: 投保统计图 - 保单列表 - 投保地块
-->
<template>
  <a-modal title="投保地块"
           :width="1200"
           :visible="visible"
           :footer="null"
           @cancel="onClose"
           :maskClosable="false"
           centered>
    <a-form layout="horizontal">

      <a-row>
        <a-col :md="6"
               :sm="24">
          <a-form-item label="地块名称"
                       :labelCol="{ span: 7 }"
                       :wrapperCol="{ span: 16, offset: 1 }">
            <a-input placeholder="请输入"
                     v-model="queryParams.landDkmc" />
          </a-form-item>
        </a-col>
        <a-col :md="7"
               :sm="24">
          <a-form-item label="地块编号"
                       :labelCol="{ span: 8 }"
                       :wrapperCol="{ span: 15, offset: 1 }">
            <a-input placeholder="请输入"
                     v-model="queryParams.landDkbm" />

          </a-form-item>
        </a-col>

        <a-col :md="8"
               :sm="24">
          <div style="margin-left:20px;padding-top:4px;">
            <a-button type="primary"
                      ghost
                      class="u_btn u_btn1"
                      @click="handleSearch">查询</a-button>

            <a-button type="primary"
                      ghost
                      class="u_btn u_btn3"
                      @click="handleReset">重置</a-button>
          </div>

        </a-col>

      </a-row>

    </a-form>
    <!-- 表格区域 -->
    <a-table ref="TableInfo"
             size="small"
             :rowKey="record => record.id"
             :columns="columns"
             :dataSource="dataSource"
             :pagination="pagination"
             :loading="loading"
             :scroll="{ x: 1000 }"
             bordered
             @change="handleTableChange">

    </a-table>
  </a-modal>

</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      rowInfo: {},
      queryParams: {},
      loading: false,
      paginationInfo: null,
      pagination: {
        // 分页
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        defaultCurrent: 1,
        defaultPageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
      },
      dataSource: [
        // { id: '111', orderName: '投保单123', personName: '投保人', status: 1, applicationType: 2, personIdCard: '150422198906143546' }

      ] // 表格列表
    }
  },
  computed: {
    columns () {
      return [
        {
          title: '地块名称',
          dataIndex: 'landDkmc',
          align: 'center'
        }, {
          title: '地块编号',
          dataIndex: 'landDkbm',
          align: 'center',
          width: 200
        }, {
          title: '四至',
          dataIndex: 'sz',
          align: 'center',
          width: 280
        }, {
          title: '地块类型',
          dataIndex: 'roamStateString',
          align: 'center'
        }, {
          title: '地块面积（亩）',
          dataIndex: 'landAcreage',
          align: 'center'
        }, {
          title: '种植面积（亩）',
          dataIndex: 'plantAcreage',
          align: 'center'
        }, {
          title: '投保面积（亩）',
          dataIndex: 'cbAcreage',
          align: 'center'
        }]
    }

  },
  methods: {
    /* 查询 */
    handleSearch () {
      this.$refs.TableInfo.pagination.current = this.pagination.defaultCurrent
      if (this.paginationInfo) {
        this.paginationInfo.current = this.pagination.defaultCurrent
        this.paginationInfo.pageSize = this.pagination.defaultPageSize
      }
      this.paginationInfo = null
      this.fetch({
        ...this.queryParams
      })
    },
    /* 重置 */
    handleReset () {
      this.queryParams = {}
      // 重置分页
      this.$refs.TableInfo.pagination.current = this.pagination.defaultCurrent
      if (this.paginationInfo) {
        this.paginationInfo.current = this.pagination.defaultCurrent
        this.paginationInfo.pageSize = this.pagination.defaultPageSize
      }
      this.paginationInfo = null
      this.fetch({...this.queryParams})
    },
    /* 关闭 */
    async onClose () {
      await this.handleReset()
      this.$emit('close')
    },
    handleTableChange (pagination) {
      this.paginationInfo = pagination
      this.fetch(this.queryParams)
    },
    /* 投保地块 */
    handleInsuranceLot () {

    },
    fetch (params = {}) {
      this.loading = true
      params.slipPersonId = this.rowInfo.id || '' // 投保人id
      if (this.paginationInfo) {
        // 如果分页信息不为空，则设置表格当前第几页，每页条数，并设置查询分页参数
        this.$refs.TableInfo.pagination.current = this.paginationInfo.current
        this.$refs.TableInfo.pagination.pageSize = this.paginationInfo.pageSize
        params.pageSize = this.paginationInfo.pageSize
        params.pageNum = this.paginationInfo.current
      } else {
        // 如果分页信息为空，则设置为默认值
        params.pageSize = this.pagination.defaultPageSize
        params.pageNum = this.pagination.defaultCurrent
      }
      this.$get('/insurance/policy/getSlipLandList', {
        ...params
      }).then(r => {
        this.loading = false
        let data = r.data
        const pagination = { ...this.pagination }
        pagination.total = data.total
        this.dataSource = data.rows

        this.pagination = pagination
      })
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.$nextTick(() => {
            this.handleSearch()
          })
        }
      }

    }

  }

}
</script>
<style scoped lang="less">
/* model框 */
/deep/ .ant-modal {
  background: #010c16;
  border: 1px solid #18a6d5;
  padding: 20px;
}
/deep/.ant-modal-header {
  background: #010c16;
  border: none;
}
/deep/.ant-modal-title {
  border: none !important;
  font-weight: bold;
  font-size: 18px;
  color: #fff;
}
/deep/.ant-modal-close,
/deep/.ant-modal-close-x {
  right: 40px;
  top: 30px;
  color: #279cd1;
  background: rgba(67, 152, 231, 0.33);
  border: 1px solid #18a6d5;
  width: 38px;
  height: 38px;
  line-height: 38px;
}
/deep/.ant-modal-content {
  background: #010c16;
}
.u_btn {
  border-radius: 4px !important;
  color: #fff !important;
  border-color: #0ca3f1 !important;
}
.u_btn1 {
  background: rgba(10, 64, 108, 1) !important;
}
// .u_btn2 {
//   background: rgba(8, 78, 114, 1) !important;
// }
.u_btn3 {
  background: rgba(4, 70, 89, 1) !important;
}
.opt_box {
  a {
    color: #44b6ff;
  }
}
/deep/ .ant-btn {
  padding: 0 25px;
  margin-right: 4px;
}
/deep/ .ant-form {
  margin-bottom: 20px;
}
/deep/ .ant-form-item-label > label {
  color: #fff;
}
/deep/ .ant-select-selection,
/deep/ .ant-input {
  background: rgba(10, 64, 108, 1);
  border: 1px solid #0ca3f1;
  color: #fff;
}
/deep/ .ant-input::placeholder {
  color: #fff;
}
/deep/.ant-input,
/deep/.ant-select-selection__placeholder,
/deep/.ant-select-search__field__placeholder {
  color: #fff;
}
/deep/ .ant-select-arrow .ant-select-arrow-icon svg {
  color: #0ca3f1;
}
// /deep/.ant-select-dropdown {
//   border: 1px solid red !important;
//   box-shadow: none;
// }
// /deep/.ant-select-dropdown-menu-item {
// color: red;
// }
/* table */
/deep/.ant-table-thead > tr > th {
  background: none;
  color: #fff;
  // padding:10px 2px;
  background: #032f54;
  border: none;
}
/deep/.ant-table-small {
  border: none;
}
/deep/.ant-table-small.ant-table-bordered .ant-table-content {
  border: none;
}
/deep/.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th {
  background: #032f54;
  padding: 10px 2px;
}
/deep/.ant-table-bordered .ant-table-body > table {
  border: none;
}
/deep/.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th,
.ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr {
  border: none;
}
/deep/.ant-table-fixed-left table,
.ant-table-fixed-right table {
  background: none;
}
/deep/.ant-table-placeholder,
/deep/.ant-table-bordered.ant-table-empty .ant-table-placeholder,
/deep/.ant-table-bordered .ant-table-tbody > tr > td {
  background: none;
  border: none;
  color: #fff;
}
/deep/.ant-empty-normal {
  color: #fff;
}
/deep/
  .ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-tbody
  > tr:nth-child(2n-1)
  > td {
  padding: 17px 4px;
}
/deep/ .ant-table-tbody tr:nth-child(2n) {
  background: rgba(14, 92, 157, 0.2);
}
/deep/.ant-table-tbody
  > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td {
  background: rgba(14, 92, 157, 0.4);
}
/* 分页 */
/deep/ .ant-pagination-item-active {
  background: none;
}
/deep/.ant-pagination-item a {
  color: #fff;
}
/deep/.ant-pagination-options-quick-jumper input {
  background: rgba(10, 64, 108, 1);
  border: 1px solid #0ca3f1;
  color: #fff;
}
/deep/.ant-pagination-options-quick-jumper {
  color: #fff;
}
/deep/.anticon {
  color: #fff;
}
/deep/.ant-pagination.mini .ant-pagination-total-text{
color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/InsuranceLot.vue